<template>
  <div class="header--bg">
    <div class="header container">
      <div class="header__logo">
        <img src="../../assets/crowdfunding/logo.svg" alt="crowdfunding - home">
      </div>
      <div class="header__hamburger">
        <img
          src="../../assets/crowdfunding/icon-hamburger.svg"
          alt="open - navigation"
          v-if="!open"
          @click="toggle"
        />
        <img
          src="../../assets/crowdfunding/icon-close-menu.svg"
          alt="open - navigation"
          v-if="open"
          @click="toggle"
        />
      </div>
    </div>
    <div v-if="open" class="mobile-nav">
      <MobileNav />
    </div>
  </div>
</template>

<script>
import MobileNav from './nav/Mobile.vue';

export default {
  data() {
    return {
      open: true,
    };
  },
  components: {
    MobileNav,
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 60em) {
  .mobile-nav, .header__hamburger {
    display: none;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: var(--sm-spacer);

  &--bg {
    background: no-repeat url(../../assets/crowdfunding/image-hero-mobile.jpg);
    background-size: cover;
    background-position: center;
    min-height: 24rem;
  }

  &__hamburger {
    cursor: pointer;
  }
}
</style>
